import { ArrowUp } from 'lucide-react';
import { useEffect, useState } from 'react';

import { useIsMobile } from '../../../hooks/useIsMobile';
import { cn } from '../../../lib/utils';

// Floating scroll-to-top affordance for the window-scrolled app shell. Mobile
// only — on desktop the scrollbar makes returning to the top trivial.
export function BackToTop() {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobile) return;
    const onScroll = () => {
      const scrollPos = window.scrollY || document.documentElement.scrollTop;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      // Match legacy: surface past the page midpoint, never near the top.
      setVisible(maxScroll > 0 && scrollPos > maxScroll / 2 && scrollPos > 100);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={cn(
        'fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-lg',
        // Fixed light fill + dark glyph: a floating FAB needs constant contrast
        // over arbitrary (mostly dark) page content, so it does not theme-flip.
        'bg-white text-[#1f1f1f] shadow-2xl transition-opacity duration-200 active:scale-95',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
